export default __webpack_public_path__ + "alberta-fieldnurse.9a0895e1b57bf75afbac.svg";